"use strict";

function DryWeatherToDoList() {
  function organizeRoutineScreening(allToDos) {
    const canCreateScreening = canAccessRoutineScreening();

    for (const toDo of allToDos) {
      ToDoFunctions.addCommonFields(toDo, toDo.routineScreeningDryWeather);
      toDo.permissions = { ...toDo.permissions, canCreateScreening };
    }

    return allToDos;
  }

  function organizeReScreening(allToDos) {
    const canCreateScreening = canAccessRoutineScreening();

    for (const toDo of allToDos) {
      ToDoFunctions.addCommonFields(toDo, toDo.reScreeningDryWeather);
      toDo.permissions = { ...toDo.permissions, canCreateScreening };
    }

    return allToDos;
  }

  function canAccessRoutineScreening() {
    return UserRoles.getRolePermissionForUser("canCreateDryWeatherScreenings");
  }

  function getSortersDict() {
    const alphaSorter = SortUtilities.alphaSorter;

    return {
      name: alphaSorter,
      displayAddress: alphaSorter,
      assetDisplayType: alphaSorter,
      assignee: ToDoUserPicker.assigneeSort,
      dueDate: DateTime.dateComparator,
    };
  }

  function loadScreeningListeners($container) {
    $container
      .off("click", ".js-open-dry-weather-screening-todo", _onScreenClick)
      .on("click", ".js-open-dry-weather-screening-todo", _onScreenClick);
  }

  function _onScreenClick(e) {
    e.stopPropagation();
    const $row = $(this).parents("tr");
    const { assetType, id } = CompositeAssetId.parse($row.data("id"));
    DryWeatherFunctions.openDryWeatherScreening(id, assetType, null, "idde-screening");
  }

  function loadReScreeningListeners($container) {
    $container
      .off("click", ".js-open-dry-weather-re-screening-todo", _onReScreenClick)
      .on("click", ".js-open-dry-weather-re-screening-todo", _onReScreenClick);
  }

  function _onReScreenClick(e) {
    e.stopPropagation();
    const $row = $(this).parents("tr");
    const { assetType, id } = CompositeAssetId.parse($row.data("id"));
    DryWeatherFunctions.openDryWeatherScreening(id, assetType, null, "idde-rescreen");
  }

  return {
    organizeRoutineScreening,
    organizeReScreening,
    canAccessRoutineScreening,
    getSortersDict,
    loadScreeningListeners,
    loadReScreeningListeners,
  };
}

module.exports = DryWeatherToDoList();

const CompositeAssetId = require("../../general/compositeAssetId");
const DateTime = require("../../dateTime");
const DryWeatherFunctions = require("../dryWeatherFunctions");
const SortUtilities = require("../../general/sortUtilities");
const ToDoFunctions = require("../../mapFunctions/toDoFunctions");
const ToDoUserPicker = require("../../general/toDoUserPicker");
const UserRoles = require("../../login/userRoles");
